import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Cancel_account() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  async function deleteAccount() {
    let com_id = localStorage.getItem('mem_company_id');
    let com_email = localStorage.getItem('useremail');
    let com_name = localStorage.getItem('mem_company_name');
    if (!com_id) {
      alert('Company ID not found');
      return;
    }
    let confirmDelete = window.confirm(
      'Are you sure you want to permanently delete your account? This action cannot be undone.'
    );

    if (!confirmDelete) {
      return;
    }

    try {
      setLoading(true);

      const response = await fetch(
        'delete-company-account.php',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            com_id,
            com_email,
            com_name
          })
        }
      );

      const result = await response.json();
      if (result.status === 'success') {
        // clear local storage
        //localStorage.clear();
        // redirect to review page
        navigate('/review');
      } else {
        alert(result.message);
      }
    } catch (error) {
      console.log(error);
      alert('Something went wrong');
    } finally {
      setLoading(false);
    }
  }

  function backtowork() {
    navigate('/dashboard');
  }

  return (
    <div>
      <div className='container_small'>

        <div className='contentholder fullwidth pull_left'>
          <h2 className='details_pop_heading'>
            You are about to permanently cancel your account.
          </h2>

          <p>
            We’re sorry to hear that you’re planning to leave us.
            We hope your experience with our platform was valuable
            and that we were able to make the best use of your
            time and trust.
            <br /><br />

            Before you go, we would truly appreciate your feedback.
            Please let us know the reason for cancelling your
            account and share any issues or improvements you
            believe we should work on.
          </p>
        </div>

        <div className='fullwidth pull_left p-50'>

          <h2 className='innerpage_heading'>
            IMPORTANT: Please read carefully before proceeding.
          </h2>

          <div className='noticebox bottom'>
            <p className='warningtext'>
              By cancelling your account, you will permanently lose all information, documents, settings, and other company-related data stored on our platform.
              <br /><br />
              All associated data will be permanently deleted from our database and cannot be recovered in the future.
            </p>
          </div>
          <div className='vl_dsh_buttonholder'>
            <button
              className='mr-10'
              onClick={deleteAccount}
              disabled={loading}
            >
              {loading
                ? 'Deleting Account...'
                : 'I want to delete my account'}
            </button>
            <button onClick={backtowork}>Back</button>
          </div>
        </div>
      </div>
    </div>
  )
}